import React from 'react';
import {
    Typography, 
    Button,
    withStyles,
} from '@material-ui/core';
import { withRouter } from "react-router-dom";

const styles = () => ({
    root : {
        textAlign : "center",
        marginTop : 48,
    },
    title : {
        fontFamily : "'Poppins', sans-serif",
        fontSize : 36,
        marginTop : 24,
        
    },
    content : {
        fontSize : 24,
        marginTop : 16,
        fontFamily : "'Poppins', sans-serif",
    },
    button : {
        marginTop : 24,
    }
});

/**
 * Página 404
 * @param {*} param0 
 */
const Page404 = ({classes, history}) => {
    return(
        <div className={classes.root}>
            <Typography className={classes.title}>Página no encontrada</Typography>
            <Typography className={classes.content}>¡Uy! La página que está buscando ha sido eliminada o reubicada.</Typography>
            <Button 
                className={classes.button} 
                variant="outlined"
                onClick={() => history.push('/')}
                color="primary"
            >
                Regresar
            </Button>
        </div>
    );
};

export default withRouter(withStyles(styles)(Page404));


// WEBPACK FOOTER //
// ./src/components/page404/index.js